<template>
    <div class="table_group">
        <div class="status">
            <h2>{{ protocolName }}</h2>

            <AdaptivitySelector :entity="entity" :idProtocol="idProtocol" :isEditable="isEditable" :protocolName="protocolName" />

            <a v-if="isRemovableProtocol && isEditable" @click.stop="removeProtocol(idProtocol)" class="btn btn_action btn_delete" :title="'Smazat' | translate" v-translate>Smazat</a>
            <a v-if="availableStreamProfiles.length > 0 && isEditable" class="add add_expand" :class="{ open: this.addStreamProfileOpened }" @click.stop="toggleAddStreamProfile" :title="'Přidat profil streamu' | translate" v-translate>Přidat profil streamu</a>
        </div>

        <div class="filter expand_content" :class="{ open: addStreamProfileOpened }">
            <div class="field_left">
                <select-box :id="'streamProfile-'+protocolName" v-model="selectedStreamProfile" :options="streamProfileOptions">
                    <translate class="translate">Profil streamu</translate>
                </select-box>
            </div>

            <div class="field_right">
                <p class="field">
                    <input class="btn" type="submit" :value="'Přidat' | translate" @click.stop="addStreamProfile" />
                </p>
            </div>
        </div>

        <div class="table_overflow">
          <table class="vypis vypis_detail">
            <tbody :class="['sortable_' + idProtocol,{sortable: isEditable}]">
                <tr v-for="idStreamProfile in protocolSettings.stream_profile_order" :rowid="idStreamProfile" :class="'sorted_profiles_' + idProtocol" :key="'profile_' + idProtocol + '_' + idStreamProfile">
                    <td class="no_padding drag_drop"><span></span></td>

                    <td class="first_data no_padding_left" data-th="Protokol">{{ getProfileName(idStreamProfile) }}</td>
                    <td class="first_data no_padding_left" data-th="Kód">{{ getProfileCode(idStreamProfile) }}</td>

                    <td class="no_padding edit">
                        <div class="edit_inner" v-if="isEditable">
                            <a class="btn btn_action btn_delete" @click.stop="removeStreamProfile(idStreamProfile)" :title="'Smazat' | translate" v-translate>Smazat</a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</template>

<script>

import AdaptivitySelector from "./AdaptivitySelector";
export default {
    name: "StreamProfileOrder",
    components: {AdaptivitySelector},
    props: {
        entity: Object,
        idProtocol: Number|String,
        protocolSettings: Object,
        streamProfiles: Array,
        protocols: Array,
        isEditable: Boolean
    },
    mounted() {
        if (this.isEditable) {
            $('.sortable_' + this.idProtocol).sortable({
                stop: this._updateSortedStreamProfiles
            });
        }
    },
    data() {
        return {
            addStreamProfileOpened: false,
            selectedStreamProfile: null,
        }
    },
    methods: {
        getProfileName(idStreamProfile) {
            let streamProfile = this.streamProfiles.find((streamProfile) => streamProfile.id == idStreamProfile);
            return streamProfile ? streamProfile.name : null;
        },
        getProfileCode(idStreamProfile) {
          let streamProfile = this.streamProfiles.find((streamProfile) => streamProfile.id == idStreamProfile);
          return streamProfile ? streamProfile.code : null;
        },
        removeProtocol() {
            this.$emit('removeProtocol', this.idProtocol);
        },
        removeStreamProfile(idStreamProfile) {
            this.$emit('removeStreamProfile', this.idProtocol, idStreamProfile);
        },
        toggleAddStreamProfile() {
            this.addStreamProfileOpened = !this.addStreamProfileOpened;
            if (this.addStreamProfileOpened) {
                this.selectedStreamProfile = this.availableStreamProfiles[0].id;
            }
        },
        addStreamProfile() {
            this.$emit('addStreamProfile', this.idProtocol, ~~this.selectedStreamProfile);
        },
        _updateSortedStreamProfiles() {
            const newStreamProfileSort = [];

            $('.sorted_profiles_' + this.idProtocol).each((el, x) => {
                newStreamProfileSort.push(~~$(x).attr('rowid'));
            });

            this.$emit('sortStreamProfile', this.idProtocol, newStreamProfileSort);
        }
    },
    computed: {
        protocolName() {
            let protocol = this.protocols.find((protocol) => protocol.id == this.idProtocol);
            return protocol ? protocol.name : null;
        },
        availableStreamProfiles() {
            let availableStreamProfiles = this.streamProfiles.filter((streamProfile) => !this.protocolSettings.stream_profile_order.includes(streamProfile.id));

            if (availableStreamProfiles.length > 0) {
                this.selectedStreamProfile = availableStreamProfiles[0].id;
            } else {
                this.addStreamProfileOpened = false;
            }

            return availableStreamProfiles;
        },
        streamProfileOptions() {
            return this._.map(this.availableStreamProfiles, function (item) {
                return {id: item['id'], text: item['name']+' ('+item['code']+')'}
            })
        },
        isRemovableProtocol() {
            return !this.entity.protocol_order_linear_content.includes(~~this.idProtocol) && !this.entity.protocol_order_nonlinear_content.includes(~~this.idProtocol);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/StreamProfileOrder.vue